// src/pages/support/ConsultationDetail.jsx
import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getConsultationDetail,
  addConsultationComment,
} from "../../api/consultation";
import "../../styles/AdminPanel/ConsultationDetail.css";
import {
  BACK_ICON,
  Icon,
} from "../panel/user/manageShop/shared/EditShopShared";
export default function ConsultationDetail() {
  const { consultationId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const fileRef = useRef();

  const role = localStorage.getItem("role");
  const backPath =
    role === "admin"
      ? "/panel/admin/consultation"
      : "/panel/supporter/consultation";

  const load = () =>
    getConsultationDetail(consultationId)
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, [consultationId]);

  const handleComment = async (e) => {
    e.preventDefault();
    if (!text.trim()) {
      setError("متن کامنت نمی‌تواند خالی باشد.");
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("text", text);
      if (file) fd.append("attachment", file);
      await addConsultationComment(consultationId, fd);
      setText("");
      setFile(null);
      if (fileRef.current) fileRef.current.value = "";
      await load();
    } catch {
      setError("خطا در ثبت کامنت. دوباره تلاش کنید.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <p className="cd-loading">در حال بارگذاری...</p>;
  if (!data) return <p className="cd-error">اطلاعات یافت نشد.</p>;

  return (
    <div className="consultation-detail">
      {/* هدر */}
      <div className="cd-header">
        <button className="esp-back-btn" onClick={() => navigate(backPath)}>
          <Icon>{BACK_ICON}</Icon>
        </button>
        <h2>
          جزئیات درخواست — #{data.id}{" "}
          <span className={`cd-badge cd-badge--${data.source}`}>
            {data.source_display}
          </span>
        </h2>
      </div>

      {/* اطلاعات فرم */}
      <div className="cd-info">
        <div className="cd-info-row">
          <span className="cd-label">نام:</span>
          <span>{data.full_name}</span>
        </div>
        <div className="cd-info-row">
          <span className="cd-label">موبایل:</span>
          <span dir="ltr">{data.mobile}</span>
        </div>
        <div className="cd-info-row">
          <span className="cd-label">تاریخ ثبت:</span>
          <span>{new Date(data.created_at).toLocaleString("fa-IR")}</span>
        </div>

        {/* فیلدهای اختصاصی فرم مشاوره */}
        {data.source === "home" && (
          <>
            {data.business_type && (
              <div className="cd-info-row">
                <span className="cd-label">نوع کسب‌وکار:</span>
                <span>{data.business_type}</span>
              </div>
            )}
            {data.province && (
              <div className="cd-info-row">
                <span className="cd-label">استان:</span>
                <span>{data.province}</span>
              </div>
            )}
          </>
        )}

        {/* فیلدهای اختصاصی فرم تماس */}
        {data.source === "contact" && (
          <>
            {data.subject && (
              <div className="cd-info-row">
                <span className="cd-label">موضوع:</span>
                <span>{data.subject}</span>
              </div>
            )}
            {data.message && (
              <div className="cd-info-row cd-info-row--full">
                <span className="cd-label">پیام:</span>
                <p className="cd-message">{data.message}</p>
              </div>
            )}
          </>
        )}
      </div>

      {/* کامنت‌ها */}
      <div className="cd-comments-section">
        <h3>کامنت‌ها ({data.comments.length})</h3>

        {data.comments.length === 0 ? (
          <p className="cd-no-comment">هنوز کامنتی ثبت نشده.</p>
        ) : (
          <div className="cd-comments">
            {data.comments.map((c) => (
              <div key={c.id} className="cd-comment">
                <div className="cd-comment-header">
                  <strong>{c.author_name}</strong>
                  <span className="cd-comment-date">
                    {new Date(c.created_at).toLocaleString("fa-IR")}
                  </span>
                </div>
                <p className="cd-comment-text">{c.text}</p>
                {c.attachment && (
                  <a
                    href={c.attachment}
                    target="_blank"
                    rel="noreferrer"
                    className="cd-attachment"
                  >
                    مشاهده فایل پیوست
                  </a>
                )}
              </div>
            ))}
          </div>
        )}

        {/* فرم کامنت جدید */}
        <form className="cd-comment-form" onSubmit={handleComment}>
          <h4>افزودن کامنت</h4>
          {error && <p className="cd-form-error">{error}</p>}
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="متن کامنت..."
            rows={3}
            required
          />
          <div className="cd-form-row">
            <label className="cd-file-label">
              پیوست فایل (اختیاری)
              <input
                type="file"
                ref={fileRef}
                onChange={(e) => setFile(e.target.files[0] || null)}
                style={{ display: "none" }}
              />
            </label>
            {file && <span className="cd-file-name">{file.name}</span>}
            <button type="submit" disabled={submitting}>
              {submitting ? "در حال ثبت..." : "ثبت کامنت"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
